import ReactDOM from 'react-dom';

function CreatePortal({ id, render, removePortal }) {
  if (removePortal) return render;

  return (
    ReactDOM.createPortal(render, document.getElementById(id))
  );
}

export default CreatePortal;